import styled from '@emotion/styled';

interface ITheme {
  agentBubbleBackgroundColor?: string;
  agentBubbleTextColor?: string;
  backgroundColor?: string;
  bubbleBackgroundColor?: string;
  bubbleTextColor?: string;
  primaryAccentColor: string;
  primaryAccentTextColor: string;
  sendButtonBackgroundColor?: string;
  sendButtonTextColor?: string;
  suggestedResponseColor?: string;
  height: number;
  width: number;
}

export default styled as any;
